<template>
  <div>
    <div class="main-title">场地租赁</div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <el-form-item>
            <el-button icon="el-icon-edit-outline" type="primary" @click="startFormVisible = true">新增租赁信息</el-button>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="searchForm.daterange"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :disabled="user.buttons.indexOf(1020) < 0"
              :picker-options="datePickerOptions"
              @change="search(searchParams)">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="搜索编号/教练/学员"
              v-model="searchForm.query"
              clearable
              prefix-icon="el-icon-search"
              @input="inputSearch(searchParams)">
            </el-input>
          </el-form-item>
        </el-form>
        <el-button-group>
          <el-button icon="el-icon-download" size="small" @click="excel" :loading="exporting"></el-button>
          <el-button icon="el-icon-printer" size="small" @click="print"></el-button>
          <el-button icon="el-icon-refresh" size="small" @click="refresh" :loading="loading"></el-button>
        </el-button-group>
      </div>
      <el-table
        ref="table"
        :data="list"
        stripe
        border
        :height="tableHeight"
        :summary-method="getSummaries"
        show-summary
        style="width:100%"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange">
        <el-table-column
          prop="id"
          label="编号"
          width="70">
        </el-table-column>
        <el-table-column
          prop="licnum"
          label="车牌号"
          width="100">
        </el-table-column>
        <el-table-column
          prop="coach_name"
          label="教练"
          width="156">
          <template slot-scope="scope">
            {{ scope.row.school_name }}/{{ scope.row.coach_name }}
          </template>
        </el-table-column>
        <el-table-column
          label="学员"
          width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="showStudent(scope.row)">{{scope.row.student_count}}个学员</el-button>
          </template>
        </el-table-column>
        <el-table-column
          label="打印"
          width="60">
          <template slot-scope="scope">
            <el-button v-if="scope.row.pay_status === '已支付' && scope.row.status === '正常'"
            type="text" @click="printBill(scope.row)">打印</el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态"
          width="80"
          :filters="statusFilters"
          :filter-method="filterStatus"
          filter-placement="bottom-end">
        </el-table-column>
        <el-table-column
          prop="pay_status"
          label="支付状态"
          width="90"
          :filters="payStatusFilters"
          :filter-method="filterPayStatus"
          filter-placement="bottom-end">
          <template slot-scope="scope">
            <span :class="[scope.row.pay_status === '已支付' ? 'row-green' : 'row-red']">{{ scope.row.pay_status }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="price_type"
          label="计费方式"
          width="130">
        </el-table-column>
        <el-table-column
          prop="price"
          label="单价"
          width="80">
        </el-table-column>
        <el-table-column
          prop="fee"
          label="应收费用"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pay_total"
          label="实收合计"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pay_cash"
          label="现金"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pay_alipay"
          label="支付宝"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pay_wechat"
          label="微信支付"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pay_pos"
          label="银行卡"
          width="80">
        </el-table-column>
        <el-table-column
          prop="pay_balance"
          label="充值卡"
          width="80"
          v-if="[3,5,32].indexOf(user.group_id) >= 0">
        </el-table-column>
        <el-table-column
          prop="pay_virtual"
          label="挂账"
          width="80"
          v-if="user.pay_virtual == '1'">
        </el-table-column>
        <el-table-column
          prop="pay_advance"
          label="预收"
          width="80"
          v-if="user.pay_advance == '1'">
        </el-table-column>
        <el-table-column
          prop="start_time"
          label="进场时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="end_time"
          label="出场时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="use_time"
          label="时长"
          width="80">
        </el-table-column>
        <el-table-column
          prop="oper_name"
          label="操作员"
          width="70">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          width="150"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="130">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status === '正常'" type="text" style="color:red;" @click="invalid(scope.row)">作废</el-button>
            <el-button v-else type="text" @click="valid(scope.row)">恢复</el-button>
            <el-button v-if="scope.row.status === '正常' && scope.row.pay_status === '未支付'" type="text" @click="pay(scope.row)">结算</el-button>
            <el-button v-if="scope.row.status === '正常' && scope.row.pay_status === '已支付' && [3,5,32].indexOf(user.group_id) >= 0" type="text" @click="pay(scope.row, true)">重新结算</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="pageChange"
        :current-page="currentPage"
        :page-sizes="[minPageSize, 50, 100, 500]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 场地租赁表单 -->
    <el-dialog title="登记租赁信息" :visible.sync="startFormVisible">
      <el-form :model="startForm" ref="startForm" :rules="startFormRules" label-width="200px">
        <el-form-item label="场地">
          <el-select v-model="startForm.company_id">
            <el-option v-for="company in spaceList" :key="company.id" :label="company.name" :value="company.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="计费方式">
          <el-select v-model="startForm.price_type">
            <el-option label="按学员人数计费" value="按学员人数计费"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单价" v-if="[1,2,3,5,9,29,32].indexOf(user.group_id) >= 0">
          <el-input-number v-model.number="startForm.price" :step="50" style="width:180px"></el-input-number>
        </el-form-item>
        <el-form-item label="车牌号" prop="licnum">
          <el-input v-model="startForm.licnum" style="width:180px"></el-input>
        </el-form-item>
        <el-form-item label="教练" prop="coach_id">
          <el-select
            v-model="startForm.coach_id"
            filterable
            remote
            reserve-keyword
            placeholder="输入教练姓名或拼音"
            :remote-method="searchCoach"
            :loading="coachLoading">
            <el-option
              v-for="item in coachList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="startForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="startCommit" :loading="startCommiting">确 定</el-button>
        <el-button @click="startFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 学员信息窗口 -->
    <el-dialog :title="selectRow.pay_status === '未支付' ? '登记学员信息' : '学员信息'" :visible.sync="studentDialogVisible">
      <div v-if="studentLoading" style="height:100px;text-align:center;">正在加载学员信息...</div>
      <el-table v-if="!studentLoading" :data="studentList">
        <el-table-column prop="name" label="姓名"></el-table-column>
        <el-table-column prop="idcard" label="身份证号"></el-table-column>
        <el-table-column label="操作" v-if="selectRow.pay_status == '未支付'">
          <template slot-scope="scope">
            <el-button type="text" style="color:#f56c6c;" @click="delStudent(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-alert
        v-if="!studentLoading && selectRow.pay_status == '已支付'"
        title="提示:已结算的单据不能再增加或删除学员"
        type="info"
        style="margin-top:10px;"
        :closable="false">
      </el-alert>
      <el-form :model="studentForm" ref="studentForm" :rules="studentFormRules" label-width="120px" v-if="!studentLoading && selectRow.pay_status == '未支付'" style="margin-top:50px;">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="studentForm.name"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="idcard">
          <el-input v-model="studentForm.idcard"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addStudent" :loading="studentAdding">增加学员</el-button>
            <el-button @click="readIdcard" :loading="studentAdding">读身份证</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="selectRow.pay_status == '未支付'">
        <el-button type="primary" @click="goPay">现在结算</el-button>
        <el-button @click="studentDialogVisible = false">稍后结算</el-button>
      </div>
    </el-dialog>
    <!-- 付款表单 -->
    <el-dialog :title="payFormTitle" :visible="payFormVisible" :show-close="false">
      <div class="el-alert el-alert--success bill-info">
        <div class="el-alert__content">
          <span class="el-alert__title is-bold">账单信息</span>
          <p class="el-alert__description">
            车牌号:&nbsp;{{ selectRow.licnum }}
            <br/>
            租赁时间:&nbsp;{{ selectRow.start_time }}&nbsp;~&nbsp;{{ selectRow.end_time && selectRow.end_time.substr(11) }}
            <br/>
            计费方式:&nbsp;{{ selectRow.price_type }}，共{{ selectRow.student_count }}个学员，应付费用:&nbsp;<strong style="color:red">{{ selectRow.fee }}</strong>&nbsp;元
          </p>
        </div>
      </div>
      <el-form :model="payForm" ref="payForm" :rules="payFormRules" label-width="200px">
        <el-form-item label="现金支付" prop="pay_cash">
          <el-input v-model.number="payForm.pay_cash" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item label="支付宝" prop="pay_alipay">
          <el-input v-model.number="payForm.pay_alipay" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item label="微信支付" prop="pay_wechat">
          <el-input v-model.number="payForm.pay_wechat" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item label="银行卡支付" prop="pay_pos">
          <el-input v-model.number="payForm.pay_pos" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item label="挂账" prop="pay_virtual" v-if="user.pay_virtual == '1'">
          <el-input v-model.number="payForm.pay_virtual" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item label="预收" prop="pay_advance" v-if="user.pay_advance == '1'">
          <el-input v-model.number="payForm.pay_advance" style="width:194px;"></el-input>
        </el-form-item>
        
        <el-form-item label="充值卡支付" v-if="[3,5,32].indexOf(user.group_id) >= 0">
          <template v-if="payForm.pay_balance > 0">
            <span>{{ payForm.pay_balance }}元</span>
            <el-button type="text" style="padding-left:10px" @click="delBalance">取消</el-button>
          </template>
          <el-button v-else @click="payCardDialogVisible = true">点击使用充值卡</el-button>
        </el-form-item>
       
        <el-form-item label="备注">
          <el-input v-model="payForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="payCommit" :loading="payCommiting">确 定</el-button>
        <el-button @click="payClose">稍后再结算</el-button>
      </div>
    </el-dialog>
    <pay-card-dialog :visible="payCardDialogVisible" type="space_bill" :bill-id="payForm.id" :fee="payForm.pay_cash" @commit="payCardCommit" @cancel="payCardCancel"></pay-card-dialog>
  </div>
</template>

<script>
import ListFunc from '../../mixins/ListFunc'
import DatePickerOptions from '../../mixins/DatePickerOptions'
import moment from 'moment'
import _ from 'lodash'
import PayCardDialog from './PayCardDialog'
export default {
  components: {
    PayCardDialog
  },
  mixins: [ListFunc, DatePickerOptions],
  data () {
    return {
      sqlcode: 'space_bill_list',
      spaceList: [],
      searchForm: {
        query: '',
        daterange: this.user.buttons.indexOf(1020) < 0 ? [new Date(), new Date()] : []
      },
      statusFilters: [
        { text: '正常', value: '正常' },
        { text: '作废', value: '作废' }
      ],
      payStatusFilters: [
        { text: '已支付', value: '已支付' },
        { text: '未支付', value: '未支付' }
      ],
      spaceList: [],
      coachList: [],
      coachLoading: false,
      startFormVisible: false,
      startForm: {
        company_id: 0,
        licnum: '鄂A',
        coach_id: null,
        price_type: '按学员人数计费',
        price: 0,
        remark: ''
      },
      startFormRules: {
        licnum: [
          { required: true, message: '请输入车牌号', trigger: 'blur' }
        ],
        coach_id: [
          { required: true, message: '请选择教练', trigger: 'blur' }
        ]
      },
      startCommiting: false,
      studentDialogVisible: false,
      studentList: [],
      studentLoading: false,
      studentAdding: false,
      studentForm: {
        company_id: 0,
        space_bill_id: 0,
        name: '',
        idcard: ''
      },
      studentFormRules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        idcard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' }
        ]
      },
      payFormVisible: false,
      payFormTitle: '结算',
      payForm: {
        id: 0,
        pay_cash: 0,
        pay_alipay: 0,
        pay_wechat: 0,
        pay_pos: 0,
        pay_balance: 0,
        pay_virtual: 0,
        pay_advance: 0,
        remark: '',
        is_re_pay: false
      },
      payCommiting: false,
      payFormRules: {
        pay_cash: [
          { required: true, message: '无现金支付请填0', trigger: 'blur' },
          
        ],
        pay_alipay: [
          { required: true, message: '无支付宝支付请填0', trigger: 'blur' },
        ],
        pay_wechat: [
          { required: true, message: '无微信支付请填0', trigger: 'blur' },
          
        ],
        pay_pos: [
          { required: true, message: '无银行卡支付请填0', trigger: 'blur' },
          
        ],
        pay_virtual: [
          { required: true, message: '无挂账请填0', trigger: 'blur' },
        ],
        pay_advance: [
          { required: true, message: '无预收请填0', trigger: 'blur' },
        ],
      },
      selectRow: {},
      payCardDialogVisible: false,
      
    }
  },
  updated() {
    this.$nextTick(() => {
      this.$refs.table.doLayout();
    });
  },
  computed: {
    searchParams () {
      if (!this.searchForm.daterange || this.searchForm.daterange.length === 0) {
        return this.searchForm
      } else {
        return {
          query: this.searchForm.query,
          daterange_start: moment(this.searchForm.daterange[0]).format('YYYY-MM-DD'),
          daterange_end: moment(this.searchForm.daterange[1]).format('YYYY-MM-DD') + ' 23:59:59'
        }
      }
    }
  },
  mounted () {
    this.fetchSpaceList()
  },
  methods: {
    filterStatus (value, row) {
      return row.status ===  value
    },
    filterPayStatus (value, row) {
      return row.pay_status ===  value
    },
    tableRowClassName ({row, rowIndex}) {
      if (row.status === '作废' || row.status === '退款') {
        return 'row-red'
      } else {
        return ''
      }
    },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        const values = data.map(item => Number(item[column.property]))
        if (column.property === 'student_count' || column.property === 'fee'
         || column.property === 'pay_total' || column.property === 'pay_cash'
         || column.property === 'pay_alipay' || column.property === 'pay_wechat'
         || column.property === 'pay_pos'|| column.property === 'pay_virtual'|| column.property === 'pay_advance') {
          let i = -1
          sums[index] = values.reduce((prev, curr) => {
            i++
            const value = Number(curr)
            if (!isNaN(value) && data[i].status !== '作废') {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
        } else if (column.property === 'price_type') {
          sums[index] = '合计'
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
    fetchSpaceList () { // 获取场地列表
      this.$http.get('/dbapi/space_list').then(response => {
        if (response.data.success) {
          this.spaceList = response.data.list
          if (this.spaceList.length > 0) {
            this.startForm.company_id = this.spaceList[0].id
            this.startForm.price = this.spaceList[0].space_lease_price
          }
        }
      })
    },
    searchCoach (query) { // 搜索教练
      this.coachLoading = true
      this.$http.get('/dbapi/coach_combo?query=' + query).then(response => {
        this.coachLoading = false
        if (response.data.success) {
          this.coachList = response.data.list
        }
      })
    },
    invalid (row) { // 作废单据
      this.$prompt('请输入作废原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        this.$http.post('/dbapi/space_bill_invalid', {
          id: row.id,
          remark: value
        }).then(response => {
          if (response.data.success) {
            this.refresh()
          }
        })
      })
    },
    valid (row) { // 恢复单据
      this.$http.post('/dbapi/space_bill_valid', {
        id: row.id
      }).then(response => {
        if (response.data.success) {
          this.refresh()
        }
      })
    },
    startCommit: _.throttle( // 提交租赁信息
      function () {
        this.$refs.startForm.validate((valid) => {
          if (valid) {
            this.startCommiting = true
            this.$http.post('/dbapi/space_bill_new', this.startForm).then(response => {
              this.startCommiting = false
              if (response.data.success) {
                this.startFormVisible = false
                this.startForm.coach_id = null
                this.refresh()
                this.showStudent({ id: response.data.insertId, pay_status: '未支付', company_id: this.startForm.company_id }) // 显示学员信息窗口
              } else {
                this.$message({
                  type: 'error',
                  message: response.data.message
                })
              }
            })
          }
        })
      },
      1000
    ),
    showStudent (row) { // 显示学员窗口
      this.selectRow = row
      this.studentDialogVisible = true
      this.studentForm.space_bill_id = row.id
      this.studentForm.company_id = row.company_id
      this.fetchStudentList()
    },
    fetchStudentList () { // 读取学员列表
      this.studentLoading = true
      this.$http.get('/dbapi/student_list?space_bill_id=' + this.studentForm.space_bill_id).then(response => {
        this.studentLoading = false
        if (response.data.success) {
          this.studentList = response.data.list
        } else {
          this.$message({
            type: 'error',
            message: response.data.message
          })
        }
      })
    },
    addStudent () { // 添加学员
      this.$refs.studentForm.validate((valid) => {
        if (valid) {
          this.studentAdding = true
          this.$http.post('/dbapi/insert_student_space', this.studentForm).then(response => {
            this.studentAdding = false
            if (response.data.success) {
              this.fetchStudentList()
              this.$refs.studentForm.resetFields()
              this.refresh()
            } else {
              this.$message({
                type: 'error',
                message: response.data.message
              })
            }
          })
        }
      })
    },
    readIdcard () { // 读身份证
      this.studentAdding = true
      this.$idcard.read().then(data => {
        return this.$http.post('/dbapi/insert_student_space', {
          space_bill_id: this.studentForm.space_bill_id,
          company_id: this.studentForm.company_id,
          name: data.name,
          idcard: data.code
        })
      }).then(response => {
        this.studentAdding = false
        if (response.data.success) {
          this.fetchStudentList()
          this.refresh()
        } else {
          this.$message({
            type: 'error',
            message: response.data.message
          })
        }
      }).catch(() => {
        this.studentAdding = false
      })
    },
    delStudent (row) {
      this.$http.post('/dbapi/del_student_space', {
        id: row.id
      }).then(response => {
        if (response.data.success) {
          this.fetchStudentList()
          this.refresh()
        }
      })
    },
    goPay () { // 关闭学员窗口，打开结算窗口
      this.studentDialogVisible = false
      this.pay(this.selectRow)
    },
    pay (row, isRepay) { // 打开结算窗口
      let pay = parseInt(row.pay_cash) + parseInt(row.pay_alipay) + parseInt(row.pay_wechat) + parseInt(row.pay_pos) + parseInt(row.pay_balance) + parseInt(row.pay_virtual) + parseInt(row.pay_advance)
      this.selectRow = row
      this.payFormVisible = true
      this.payFormTitle = `结算: ${row.company_name} / ${row.school_name} / ${row.coach_name}`
      this.payForm.id = row.id
      this.payForm.pay_cash = parseInt(row.pay_cash)
      this.payForm.pay_alipay = parseInt(row.pay_alipay)
      this.payForm.pay_wechat = parseInt(row.pay_wechat)
      this.payForm.pay_pos = parseInt(row.pay_pos)
      this.payForm.pay_balance = parseInt(row.pay_balance)
      this.payForm.pay_virtual = parseInt(row.pay_virtual)
      this.payForm.pay_advance = parseInt(row.pay_advance)
      this.payForm.is_re_pay = isRepay
      if (pay == 0) {
        this.payForm.pay_cash = parseInt(row.fee)
      }
      this.payForm.remark = row.remark
    },
    payCommit: _.throttle( // 提交结算信息
      function () {
        this.payCommiting = true
        this.$refs.payForm.validate((valid) => {
          if (valid) {
            // 计算实付金额
            let pay = this.payForm.pay_cash + this.payForm.pay_alipay + this.payForm.pay_wechat + this.payForm.pay_pos + this.payForm.pay_balance + this.payForm.pay_virtual + this.payForm.pay_advance
            if (pay !== this.selectRow.fee) {
              this.$message({
                type: 'error',
                message: `应付${this.selectRow.fee}元，实收${pay}元，请检查!`
              })
              this.payCommiting = false
              return false
            }
            this.$http.post('/dbapi/space_pay', this.payForm).then(response => {
              this.payCommiting = false
              if (response.data.success) {
                this.$refs.payForm.resetFields()
                this.payFormVisible = false
                this.$message({
                  type: 'success',
                  message: '结算成功'
                })
                this.refresh()
                if (!this.payForm.is_re_pay) {
                  this.sendCoupon(this.selectRow) // 赠送代金券
                }
              } else {
                this.$message({
                  type: 'error',
                  message: response.data.message
                })
              }
            })
          } else {
            this.payCommiting = false
          }
        })
      },
      2000
    ), // 2秒内只允许提交一次
    payClose () { // 稍后结算
      this.payFormVisible = false
    },
    sendCoupon (row) {
      let space = this.spaceList.filter(s => s.id === row.company_id)
      if (space.length === 1) {
        space = space[0]
        if (space.space_lease_coupon_flag === '1') {
          this.$http.post('/dbapi/insert_coupon_coach', {
            company_id: row.company_id,
            coach_id: row.coach_id,
            coupon_no: new Date().getTime(),
            coupon_money: [1,2,3,5,9,29,32].indexOf(this.user.group_id) >=0 ? row.price : space.space_lease_coupon_money,
            resource: '场地租赁赠送'
          }).then(response => {
            if (response.data.success) {
              this.$message({
                type: 'success',
                message: '已赠送代金券,可以在代金券管理中查看'
              })
            }
          })
        } else if (space.space_lease_coupon_flag === '2') {
          this.$http.post('/dbapi/insert_coupon_space_student', {
            company_id: row.company_id,
            coach_id: row.coach_id,
            space_bill_id: row.id,
            coupon_money: [1,2,3,5,9,29,32].indexOf(this.user.group_id) >=0 ? row.price : space.space_lease_coupon_money,
            resource: '场地租赁赠送'
          }).then(response => {
            if (response.data.success) {
              this.$message({
                type: 'success',
                message: '已赠送代金券,可以在代金券管理中查看'
              })
            } else {
              this.$message({
                type: 'error',
                message: response.data.message
              })
            }
          })
        }
      }
    },
    printBill (row) {
      if ([7, 8].indexOf(row.company_id) >= 0) {
        window.open(this.$http.receiptBaseUrl + '/spacebill_print_4?id=' + row.id + '&token=' + localStorage.getItem('kaochang.token'))
      } else {
        window.open(this.$http.receiptBaseUrl + '/spacebill_print?id=' + row.id + '&token=' + localStorage.getItem('kaochang.token'))
      }
    },
    payCardCommit (money) {
      this.payForm.pay_balance = money
      this.payForm.pay_cash = this.payForm.pay_cash - money
      this.payCardDialogVisible = false
      this.refresh()
    },
    payCardCancel () {
      this.payCardDialogVisible = false
    },
    delBalance () {
      this.$http.post(`/dbapi/del_pay_balance_sb`, {
        id: this.payForm.id
      }).then(response => {
        if (response.data.success) {
          this.payForm.pay_balance = 0
          this.refresh()
        } else {
          this.$message({
            type: 'error',
            message: response.data.message
          })
        }
      })
    }
  }
}
</script>

<style>
.bill-info .el-alert__title {
  font-size: 16px;
}
.bill-info .el-alert__description {
  font-size: 14px;
}
.bill-info {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/rent/SpaceBills.vue